package com.eladfinish.bible.contest.screens.browse.tableOfContents

import androidx.compose.runtime.Immutable
import androidx.compose.ui.graphics.Color
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.navigation.NavigationCommand
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BookmarkData
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BrowseMode
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ChapterOrParashaOrSederData
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class BrowseColumnsState(
    val isLoading: Boolean,
    val tabStates: ImmutableList<BrowseTabUiState>,
) : StateKt

sealed class BrowseColumnsAction : ActionKt {

    data class OpenReference(
        val bookIndex: Int,
        val chapterIndex: Int,
        /** The 1-based verse to scroll to and highlight, or 0 for none. */
        val verse: Int = 0,
    ) : BrowseColumnsAction()

    data class TabAction(
        val mode: BrowseMode,
        val action: BrowseTabAction,
    ) : BrowseColumnsAction()

    data class OpenBookmark(
        val bookmarkData: BookmarkData,
    ) : BrowseColumnsAction()

    data class OpenRemoteChapterCompletion(
        val bookIndex: Int,
        val chapterIndex: Int,
        val completionDetails: String,
    ) : BrowseColumnsAction()

}

sealed class BrowseColumnsEffect : EffectKt {

    data class OpenContent(
        val navigation: NavigationCommand.Navigate,
    ) : BrowseColumnsEffect()

}

////////

@Immutable
data class BrowseTabUiState(
    val mode: BrowseMode,
    val week: Int,
    val bookList: ImmutableList<StringDesc>,
    val bookColorList: ImmutableList<Color>,
    val indexOfPickedBook: Int,
    val currentParasha: ChapterOrParashaOrSederData,
    val secondaryList: ImmutableList<Pair<StringDesc, Boolean>>, // pair of: name + isIncluded
) {
    val shouldPrefixChapterByCheckmark
        get() = mode == BrowseMode.BIBLE_MODE
    val shouldShowCurrentParasha
        get() = mode == BrowseMode.CHUMASH_MODE

    /** Without books (the "שונות" tab) the list is the only column, and an item opens on a tap. */
    val hasSecondaryList
        get() = mode.hasBooks
}

sealed class BrowseTabAction {
    data class BookClicked(val index: Int, val longClick: Boolean) : BrowseTabAction()
    data class PartClicked(val index: Int) : BrowseTabAction()
    data object CurrentParashaClicked : BrowseTabAction()
}
